<template>
  <div>
    <div class="main">
      <div><img src="../../../src/assets/logoutPageIcon.svg" /></div>
      <div style="margin-top: 27px">
        <span class="error_text">注销成功</span>
      </div>
      <div style="margin-top: 12px">
        <span class="text">您已经成功退出单点登录，谢谢使用！</span>
      </div>
      <div style="margin-top: 47px">
        <el-button @click="againlogin">重新登录</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    if (this.$route.query && this.$route.query.isSwitchAccount == "1") {
      this.againlogin();
    }
  },
  methods: {
    againlogin() {
      this.$store.dispatch("ssologin", {
        cb: (data) => {
          console.log(data);
        },
      });
    },
    changeaccount() {
      let param = { isSwitchAccount: 1 };
      this.$store.dispatch("ssologout", {
        param,
        cb: (data) => {
          console.log(data);
        },
      });
    },
  },
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.main {
  max-width: 1140px;
  // margin-right: auto;
  // margin-left: auto;
  padding: 217px 15px 0;
  margin: auto;
  text-align: center;
}
.contain {
  color: #155724;
  // background-color: #d4edda;
  border-color: #c3e6cb;
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.div_flex {
  display: flex;
  justify-content: space-around;
}
.error_text {
  color: #000000;
  opacity: 0.85;
  display: inline-block;
  font-size: 34px;
}
.text {
  color: #000000;
  opacity: 0.65;
  display: inline-block;
  font-size: 18px;
}
</style>